import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { LOCAL_STORAGE } from '../injection-tokens';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class LocalStorageService extends StorageService {
  constructor(
    @Inject(LOCAL_STORAGE) public storage: Storage,
    @Inject(PLATFORM_ID) public platformId: Object,
  ) {
    super();
    this.storageType = 'local';
  }
}
